import React, { useEffect, useState } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import inventory from "../../../Data/inventory.json";
import products from "../../../Data/products.json";
import { get_all_inventories } from "../../../Controllers/Inventory/Batch";
import toast from "react-hot-toast";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import { get_all_inventories_reports } from "../../../Controllers/Dashboard/Dashboard";
import { useRef } from "react";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import formatDateDDMMYYYY from "../../../Main/formatDate";
import StockFL from "../../../Componets/FormatStock";

const InventoryReport = () => {
  let componentRef = useRef();
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [role, setRole] = useState("");

  const headers = {
    name: "Inventory batch",
    pagination: {
      currentPage: 1,
      totalCount: 0,
      totalPages: 0,
    },
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        value: null,
        allowClear: true,
        options: [
          { value: 1, label: "Name [A-Z]" },
          { value: 2, label: "Name [Z-A]" },

          { value: 3, label: "Purchase (Low)" },
          { value: 4, label: "Purchase (High)" },

          { value: 5, label: "Price/Unit (Low)" },
          { value: 6, label: "Price/Unit (High)" },

          { value: 7, label: "Sale (Low)" },
          { value: 8, label: "Sale (High)" },

          { value: 9, label: "Stock (Low)" },
          { value: 10, label: "Stock (High)" },

          { value: 11, label: "Expiry (ASC)" },
          { value: 12, label: "Expiry (DES)" },

          { value: 13, label: "Margin (Low)" },
          { value: 14, label: "Margin (High)" },

          { value: 15, label: "Gain (Low)" },
          { value: 16, label: "Gain (High)" },

          { value: 17, label: "Total Sale (Low)" },
          { value: 18, label: "Total Sale (High)" },

          { value: 19, label: "Total Purchase (Low)" },
          { value: 20, label: "Total Purchase (High)" },
        ],
      },
      {
        type: "filter",
        name: "product",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Product",
        api: "get-all-products",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "supplier",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Supplier",
        api: "get-all-suppliers",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "purchase",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Purchase",
        api: "get-all-purchase-orders",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Inventory",
          path: "",
        },
      ],
      total: [
        { value: 0, label: "Total" },
        { value: 0, label: "Active" },
        { value: "0", label: "Inactive" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const [total, setTotals] = useState(0);
  const [totalSales, setTotalsSales] = useState(0);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        product: tabledata?.product,
        supplier: tabledata?.supplier,
        purchase: tabledata?.purchase,
        branch: tabledata?.branch,
        date: tabledata?.date,
      };

      const products = await get_all_inventories_reports(data);

      if (products?.status) {
        setBody(products?.data?.data);
        setRole(products?.data?.role);
        setLoader(false);
        setTotals(products?.data?.grand_total);
        setTotalsSales(products?.data?.grand_sale_total);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  const downloadCSV = () => {
    if (!body || body.length === 0) {
      console.log("No data available for download");
      toast.error("No data available to download");
      return;
    }

    try {
      const header = [
        "S.No",
        "Name",
        "Batch",
        "Supplier",
        "Purchase Number",
        "Branch",
        "Expiry",
        "Tax",
        "Purchase Price",
        "Price Per Unit",
        "Sale",
        "Margin",
        "Gain",
        "Stock(Full | Loose)",
        "Total (P)",
        "Total (S)",
      ];

      const rows = body.map((item, index) => [
        index + 1,
        item?.product?.name || "-",
        item?.number || "-",
        item?.supplier?.name || "-",
        item?.purchase?.number || "-",
        item?.branch?.name || "-",
        formatDate(item?.expiry_date) || "-",
        item?.tax ?? 0,
        item?.purchase_price ?? 0,
        item?.price_per_unit ?? 0,
        item?.sale_price ?? 0,
        item?.margin ?? 0,
        item?.gain ?? 0,
        item?.stock ?? 0,
        item?.total ?? 0,
        item?.total_sales ?? 0,
      ]);

      const csvContent = [header, ...rows]
        .map((row) => row.map((field) => `"${field}"`).join(","))
        .join("\n");

      const encodedContent = new TextEncoder().encode("\uFEFF" + csvContent);

      const blob = new Blob([encodedContent], {
        type: "text/csv;charset=utf-8",
      });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Inventory_Report_${new Date().toLocaleDateString().replace(/\//g, "_")}.csv`;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to generate CSV file");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!role) return;

    let updatedHeader = { ...headers };

    if (role !== "SUPERADMIN") {
      updatedHeader.components = updatedHeader.components.filter(
        (item) => item.name !== "branch",
      );
    }

    setHeader(updatedHeader);
  }, [role]);

  // let total_purchase = 0;

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div className="text-right flex gap-3 justify-end mt-4">
          <Button
            className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
            type="primary"
            onClick={downloadCSV}
          >
            Download CSV
          </Button>

          <ReactToPrint
            trigger={() => (
              <Button
                className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
                type="primary"
              >
                Download PDF
              </Button>
            )}
            content={() => componentRef}
            pageStyle={`
              @page {
                size: landscape;
                margin: 10mm;
              }
                     
              @media print {
                tfoot {
                  position: static !important;
                  bottom: auto !important;
                }
                thead { 
                  display: table-header-group !important;
                }
                tfoot {
                                       display: table-row-group !important;
                                     }
                                   }
                     
                                     table {
                                     border-collapse: collapse;
                                     width: 100%;
                                   }
                                   th, td {
                                     border: 1px solid #ddd;
                                     padding: 6px;
                                   }
                                   th {
                                     background-color: #f4f4f4;
                                   }
                                     @media print {

  table, thead, tbody, tfoot, tr, th, td {
    border: 1px solid #000 !important;
    border-collapse: collapse !important;
  }

  th {
    background-color: #f4f4f4 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  table {
    width: 100% !important;
    border-collapse: collapse !important;
  }

  thead, tfoot {
    position: static !important;
  }
}
                                 `}
          />
        </div>
        <ScrollWrapper>
          <div
            className="max-h-[70vh] overflow-y-auto scrollbar-hide remove-scroll-limit"
            ref={(el) => (componentRef = el)}
          >
            <table className="w-full bg-white">
              <thead className="text-gray-500 sticky top-0 bg-white z-10">
                <tr className="text-sm">
                  <td className="border p-4 ">S.No</td>
                  <td className="border p-4">Name</td>
                  <td className="border p-4">Batch</td>
                  <td className="border p-4">Supplier</td>
                  <td className="border p-4">Purchase</td>
                  <td className="border p-4">Branch</td>
                  <td className="border p-4">Expiry</td>
                  <td className="border p-4">Tax</td>
                  <td className="border p-4">Purchase</td>
                  <td className="border p-4">Price/unit</td>
                  <td className="border p-4">Sale</td>
                  <td className="border p-4">Margin</td>
                  <td className="border p-4">Gain</td>
                  <td className="border p-4">Stock(Full | Loose)</td>
                  <td className="border p-4">Total&nbsp;(P)</td>
                  <td className="border p-4">Total&nbsp;(S)</td>
                </tr>
              </thead>
              <tbody>
                {body?.map((value, index) => {
                  return (
                    <tr className="text-xs">
                      <td className="border p-4">{index + 1}</td>
                      <td className="border p-4">{value?.product?.name}</td>
                      <td className="border p-4 whitespace-nowrap">
                        #BATCH-{value?.number}
                      </td>
                      <td className="border p-4">{value?.supplier?.name}</td>
                      <td className="border p-4">
                        {value?.purchase?.number
                          ? `#PO${value?.purchase?.number}`
                          : ""}
                      </td>
                      <td className="border p-4 text-xs ">
                        {value?.branch?.name}
                      </td>
                      <td className="border p-4">
                        {value?.expiry_date
                          ? formatDateDDMMYYYY(value?.expiry_date)
                          : ""}
                      </td>
                      <td className="border p-4">{value?.tax}</td>
                      <td className="border p-4">
                        {value?.purchase_price?.toFixed(3)}
                      </td>
                      <td className="border p-4">
                        {value?.price_per_unit?.toFixed?.(3)}
                      </td>
                      <td className="border p-4">
                        {value?.sale_price?.toFixed(3)}
                      </td>
                      <td className="border p-4">
                        {value?.margin?.toFixed(3)}%
                      </td>
                      <td className="border p-4">{value?.gain?.toFixed(3)}</td>
                      <td className="border p-4">
                        <StockFL
                          totalStock={value?.stock}
                          conversion={
                            value?.product_units_details?.[0]?.conversion || 1
                          }
                        />
                      </td>
                      <td className="border p-4">
                        {value?.total?.toFixed?.(3)}
                      </td>
                      <td className="border p-4">
                        {value?.total_sales?.toFixed?.(3)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot className="sticky bottom-0 bg-white z-10">
                <tr className="text-sm font-medium">
                  <td className="border p-2 text-medium ">TOTAL</td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4 text-medium">
                    {total?.toFixed(3)}
                  </td>
                  <td className="border p-4 text-medium">
                    {totalSales?.toFixed(3)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default InventoryReport;
